import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollPricingDataImplEncoder } from "../../encoder/FwdRollPricingDataImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollPricingData } from "../FwdRollPricingData";

export class FwdRollPricingDataImpl extends ConcreteEncodable implements FwdRollPricingData {
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollPricingDataImpl";

  /*FID=1*/
  public diEventId: string;
  /*FID=2*/
  public portfolioId: string;
  /*FID=3*/
  public clientCd: string;
  /*FID=4*/
  public fixingDts: CubiqTS.moment.Moment | null = null;
  /*FID=7*/
  public fixingCd: string | null = null;
  /*FID=8*/
  public lastSaveDts: CubiqTS.moment.Moment | null = null;
  /*FID=9*/
  public lastSaveUserCode: string;
  /*FID=10*/
  public lastSaveUserId: CubiqTS.Long | null = null;
  /*FID=11*/
  public netCurrencyPositions: Array<CubiqTS.FwdRollCurrencyNetPricing> | null = null;
  /*FID=12*/
  public netDealtPairPositions: Array<CubiqTS.FwdRollDealtPairNetPricing> | null = null;
  /*FID=13*/
  public orderAllocations: Array<CubiqTS.FwdRollOrderAllocationPricing> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FwdRollPricingDataImplEncoder.Instance;
    this.setEncodableType(FwdRollPricingDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FwdRollPricingDataImpl[" +
      "diEventId=" +
      this.diEventId +
      "portfolioId=" +
      this.portfolioId +
      "clientCd=" +
      this.clientCd +
      "fixingDts=" +
      this.fixingDts +
      "fixingCd=" +
      this.fixingCd +
      "lastSaveDts=" +
      this.lastSaveDts +
      "lastSaveUserCode=" +
      this.lastSaveUserCode +
      "lastSaveUserId=" +
      this.lastSaveUserId +
      "netCurrencyPositions=" +
      this.netCurrencyPositions +
      "netDealtPairPositions=" +
      this.netDealtPairPositions +
      "orderAllocations=" +
      this.orderAllocations +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
